// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"152":"ed2ebcfa","251":"c8a28208","490":"3b6ed448","665":"941c8722"}[chunkId] + ".chunk.css";
};